/* Progressive enhancement: links and native details work without JavaScript. */
(() => {
  const menus = () => [...document.querySelectorAll('.pst-shop,.pst-mobile-menu')];
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const inside = event.target.closest('.pst-shop,.pst-mobile-menu');
    menus().forEach(menu => {
      if (menu !== inside || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = menus().find(menu => menu.open && menu.contains(document.activeElement));
    menus().forEach(menu => { menu.open = false; });
    open?.querySelector('summary')?.focus();
  });
})();
